export function SimpleTable(props: {
	widths?: (number | string)[];
	headers: (string | JSX.Element)[];
	rows: (string | JSX.Element)[][];
}) {
	return (
		<div className="h-[36rem] overflow-x-auto">
			<table className="sesh-table relative">
				<thead>
					<tr>
						{props.headers.map((header, index) => (
							<th key={index} className="sticky top-0">
								<div
									className="flex"
									style={{
										width:
											props.widths?.[index] ?? undefined,
									}}
								>
									<div className="">{header}</div>
								</div>
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{props.rows.map((row, p_index) => (
						<tr key={p_index}>
							{row.map((el, c_index) => (
								<td
									key={c_index}
									title={
										typeof el === "string" ? el : undefined
									}
								>
									<div className="w-24 overflow-hidden overflow-ellipsis">
										{el}
									</div>
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
